var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ maxWidth: _vm.maxWidth })},[_c('nuxt-img',_vm._b({},'nuxt-img',{ ..._vm.$attrs, ..._vm.$props },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }